import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { SaveUserProfileDto } from '../model';

class UserClient extends BaseClient {
  saveUserProfile(payload: SaveUserProfileDto): AxiosPromise<void> {
    return this.request({
      url: `${hosts.userApi}/users/profile/`,
      method: 'PATCH',
      data: payload,
    });
  }
}

export const userClient = new UserClient();
